import {
  BarChart3, CarFront, ClipboardList, FileText, Link2, LogOut, Menu, Settings, ShieldCheck,
  UsersRound, X,
} from 'lucide-react'
import { useState } from 'react'
import { APP_DATE_JA } from '../../data/seed'

export const adminNav = [
  { id: 'dashboard', label: '本日の状況', icon: BarChart3 },
  { id: 'records', label: 'チェック記録', icon: ClipboardList },
  { id: 'report', label: '月次報告書', icon: FileText },
  { id: 'journals', label: '走行距離・日報', icon: ClipboardList },
  { id: 'drivers', label: 'ドライバー', icon: UsersRound },
  { id: 'vehicles', label: '車両', icon: CarFront },
  { id: 'integration', label: '連携設定', icon: Link2 },
]

export default function AdminShell({ page, onPage, onLogout, children, dateLabel = APP_DATE_JA, userName = '鈴木 管理者' }) {
  const [mobileOpen, setMobileOpen] = useState(false)
  const selected = adminNav.find((item) => item.id === page) || adminNav[0]

  const choosePage = (id) => {
    onPage(id)
    setMobileOpen(false)
  }

  return (
    <div className="admin-app">
      <aside className={`sidebar ${mobileOpen ? 'sidebar--open' : ''}`}>
        <div className="sidebar__brand"><ShieldCheck /><span>ALCO LOG</span><button aria-label="メニューを閉じる" onClick={() => setMobileOpen(false)}><X /></button></div>
        <nav aria-label="管理メニュー">
          {adminNav.map(({ id, label, icon: Icon }) => <button key={id} className={page === id ? 'active' : ''} onClick={() => choosePage(id)}><Icon /><span>{label}</span></button>)}
        </nav>
        <div className="sidebar__user"><span className="avatar">{userName.slice(0, 1)}</span><span><strong>{userName}</strong><small>安全管理部</small></span><button title="ログアウト" aria-label="ログアウト" onClick={onLogout}><LogOut /></button></div>
      </aside>
      <div className="admin-main">
        <header className="admin-topbar">
          <button className="menu-button" aria-label="メニューを開く" onClick={() => setMobileOpen(true)}><Menu /></button>
          <h1>{selected.label === '本日の状況' ? '安全点呼・アルコールチェック管理' : selected.label}</h1>
          <div className="admin-topbar__right"><span>{dateLabel}</span><button title="設定" aria-label="設定" onClick={() => onPage('integration')}><Settings /></button></div>
        </header>
        <main className="admin-content">{children}</main>
      </div>
    </div>
  )
}
